var DESCRIPTORS = require('../internals/descriptors');

var fails = require('../internals/fails');

var createElement = require('../internals/document-create-element'); // Thanks to IE8 for its funny defineProperty


module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});